import { convertMedia, convertSeekResult, playerAvailableAudioTracks, playerAvailableSubtitlesTracks, playerCreate, playerCreateZapi, playerDestroy, playerGetProperties, playerPause, playerPlay, playerPlayLive, playerPlayProgram, playerPlayRecording, playerPlayUrl, playerPlayVod, playerPlayVodTrailer, playerSeek, playerSeekBackward, playerSeekForward, playerSeekToAdBreakEnd, playerSelectedAudioTrack, playerSelectedSubtitlesTrack, playerSetAudioTrack, playerSetStaticProgramInfoCallback, playerSetSubtitlesTrack, playerStop, playerThumbnailData, } from './actions';
import { ContainerType, InternalPlayerContainer, } from './player-container';
import { EventKey, TafAdapterBase, } from './taf-adapter-base';
export class TafAdapter extends TafAdapterBase {
    player = null;
    async handleSdk(src, action) {
        const decoded = this.decodeAction(action);
        if (!decoded) {
            return Promise.resolve();
        }
        const { actionKey, actionValue, } = decoded;
        switch (actionKey) {
            case 'playerCreate':
                this.setPlayer(new InternalPlayerContainer(ContainerType.PLAYER, await playerCreate(actionValue, (output) => {
                    this.dispatchOutput(output);
                })));
                break;
            case 'playerPlayUrl':
                await playerPlayUrl(this.player, actionValue);
                break;
            case 'playerSeek':
                return {
                    seekResult: convertSeekResult(playerSeek(this.player, actionValue)),
                };
            case 'playerGetAvailableAudioTracks':
                return playerAvailableAudioTracks(this.player);
            case 'playerGetSelectedAudioTrack':
                return playerSelectedAudioTrack(this.player);
            case 'playerGetAvailableSubtitlesTracks':
                return playerAvailableSubtitlesTracks(this.player);
            case 'playerGetSelectedSubtitlesTrack':
                return playerSelectedSubtitlesTrack(this.player);
            case 'playerSetAudioTrack':
                playerSetAudioTrack(this.player, actionValue);
                break;
            case 'playerSetSubtitlesTrack':
                playerSetSubtitlesTrack(this.player, actionValue);
                break;
            case 'playerDestroy':
                await playerDestroy(this.player);
                this.cleanPlayer();
                break;
            case 'playerStop':
                await playerStop(this.player);
                break;
            case 'playerSeekForward':
                return {
                    seekResult: convertSeekResult(await playerSeekForward(this.player, actionValue)),
                };
            case 'playerSeekBackward':
                return {
                    seekResult: convertSeekResult(await playerSeekBackward(this.player, actionValue)),
                };
            case 'playerSeekToAdBreakEnd':
                return {
                    seekResult: convertSeekResult(playerSeekToAdBreakEnd(this.player)),
                };
            case 'playerGetProperties':
                return playerGetProperties(this.player);
            case 'playerPause':
                await playerPause(this.player);
                break;
            case 'playerPlay':
                playerPlay(this.player);
                break;
            case 'playerSetStaticProgramInfoCallback':
                playerSetStaticProgramInfoCallback(this.player, actionValue);
                break;
            case 'playerThumbnailData':
                return {
                    thumbnailData: {
                        data: playerThumbnailData(this.player, actionValue) ?? undefined,
                    },
                };
            default:
                console.error('Unsupported action', src, src.id);
                throw new Error(`Unsupported action ${JSON.stringify(action)}`);
        }
        return Promise.resolve();
    }
    async handleSdkZapi(src, action) {
        const decoded = this.decodeAction(action);
        if (!decoded) {
            return Promise.resolve();
        }
        const { actionKey, actionValue, } = decoded;
        switch (actionKey) {
            case 'playerCreate':
                this.setPlayer(new InternalPlayerContainer(ContainerType.PLAYER_ZAPI, await playerCreateZapi(actionValue, (output) => {
                    this.dispatchOutput(output);
                })));
                break;
            case 'playerPlayLive':
                return {
                    mediaChanged: convertMedia(await playerPlayLive(this.player, actionValue)),
                };
            case 'playerPlayProgram':
                return {
                    mediaChanged: convertMedia(await playerPlayProgram(this.player, actionValue)),
                };
            case 'playerPlayRecording':
                return {
                    mediaChanged: convertMedia(await playerPlayRecording(this.player, actionValue)),
                };
            case 'playerPlayVod':
                return {
                    mediaChanged: convertMedia(await playerPlayVod(this.player, actionValue)),
                };
            case 'playerPlayVodTrailer':
                return {
                    mediaChanged: convertMedia(await playerPlayVodTrailer(this.player, actionValue)),
                };
            default:
                console.error('Unsupported action', src, src.id);
                throw new Error(`Unsupported action ${JSON.stringify(action)}`);
        }
        return Promise.resolve();
    }
    handle(action) {
        const decoded = this.decodeAction(action);
        if (!decoded) {
            return Promise.resolve();
        }
        const { actionKey, actionValue, } = decoded;
        switch (actionKey) {
            case 'sdk':
                return this.handleSdk(action, actionValue);
            case 'sdkZapi':
                return this.handleSdkZapi(action, actionValue);
            default:
                return super.handle(action);
        }
    }
    async tafCleanupSession() {
        if (this.player) {
            await playerDestroy(this.player);
            this.cleanPlayer();
        }
        super.tafCleanupSession();
    }
    setPlayer(player) {
        this.player = player;
        this.dispatchEvent(EventKey.PlayerCreated, player);
    }
    cleanPlayer() {
        this.player = null;
        this.dispatchEvent(EventKey.PlayerDestroyed);
    }
    getPlayer() {
        return this.player;
    }
}
